import { render } from "./AccessibilityIcon.vue?vue&type=template&id=0f2fe042"
import script from "./AccessibilityIcon.vue?vue&type=script&lang=js"
export * from "./AccessibilityIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__